import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import CUIBox from 'connect-dot-com-ui-components/Components/CUIBox/CUIBox';
import CUICenter from 'connect-dot-com-ui-components/Components/CUICenter/CUICenter';
import { CUIHeading } from 'connect-dot-com-ui-components/Components/CUIHeading/CUIHeading';
import CUILink from 'connect-dot-com-ui-components/Components/CUILink/CUILink';
import { generateBasicBreakpointObject } from 'connect-dot-com-ui-components/utils/layout';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NavMarker } from 'react-rhumb';
import HomepageLayout from '../layout/Homepage/HomepageLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Heading = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CUIHeading, Object.assign({
    marginBottom: 2
  }, rest, {
    children: children
  }));
};
const Section = ({
  children
}) => /*#__PURE__*/_jsx(CUIBox, {
  marginBottom: 4,
  children: children
});
const Paragraph = ({
  children
}) => /*#__PURE__*/_jsx(CUIBox, {
  as: "p",
  marginBottom: 4,
  children: children
});
export default function CodeOfConductPage() {
  return /*#__PURE__*/_jsxs(HomepageLayout, {
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "CODE_OF_CONDUCT_LOAD"
    }), /*#__PURE__*/_jsx(CUICenter, {
      flexDirection: "column",
      "data-test-id": "communities-zero-state",
      children: /*#__PURE__*/_jsxs(CUIBox, {
        maxW: generateBasicBreakpointObject('100%', 1030),
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h2",
          id: "introduction",
          "data-test-id": "code-of-conduct-page",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.codeOfConduct.heading"
          })
        }), /*#__PURE__*/_jsxs(Section, {
          children: [/*#__PURE__*/_jsx(Heading, {
            as: "h3",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.introduction.heading"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.introduction.paragraph1"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.introduction.paragraph2"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx("em", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.codeOfConduct.introduction.paragraph3"
              })
            })
          })]
        }), /*#__PURE__*/_jsxs(Section, {
          children: [/*#__PURE__*/_jsx(Heading, {
            as: "h3",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.expectations.heading"
            })
          }), /*#__PURE__*/_jsx(Heading, {
            as: "h4",
            id: "respectful",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.expectations.respectful.title"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.expectations.respectful.body"
            })
          }), /*#__PURE__*/_jsx(Heading, {
            as: "h4",
            id: "relevant",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.expectations.relevant.title"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.expectations.relevant.body"
            })
          }), /*#__PURE__*/_jsx(Heading, {
            as: "h4",
            id: "responsible",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.expectations.responsible.title"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.expectations.responsible.body"
            })
          }), /*#__PURE__*/_jsx(Heading, {
            as: "h4",
            id: "privacy",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.expectations.privacy.title"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.expectations.privacy.body"
            })
          }), /*#__PURE__*/_jsx(Heading, {
            as: "h4",
            id: "involved",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.expectations.involved.title"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.expectations.involved.body"
            })
          })]
        }), /*#__PURE__*/_jsxs(Section, {
          children: [/*#__PURE__*/_jsx(Heading, {
            as: "h3",
            id: "unacceptable",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.unacceptableBehaviours.title"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.unacceptableBehaviours.introduction"
            })
          }), /*#__PURE__*/_jsx(Heading, {
            as: "h4",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.unacceptableBehaviours.behaviours.privacy.title"
            })
          }), /*#__PURE__*/_jsx("ul", {
            style: {
              marginBottom: '16px',
              marginLeft: '40px'
            },
            children: /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.codeOfConduct.unacceptableBehaviours.behaviours.privacy.bulletPoint1"
              })
            })
          }), /*#__PURE__*/_jsx(Heading, {
            as: "h4",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.unacceptableBehaviours.behaviours.spam.title"
            })
          }), /*#__PURE__*/_jsxs("ul", {
            style: {
              marginBottom: '16px',
              marginLeft: '40px'
            },
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.codeOfConduct.unacceptableBehaviours.behaviours.spam.bulletPoint1"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.codeOfConduct.unacceptableBehaviours.behaviours.spam.bulletPoint2"
              })
            })]
          }), /*#__PURE__*/_jsx(Heading, {
            as: "h4",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.unacceptableBehaviours.behaviours.safety.title"
            })
          }), /*#__PURE__*/_jsxs("ul", {
            style: {
              marginBottom: '16px',
              marginLeft: '40px'
            },
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.codeOfConduct.unacceptableBehaviours.behaviours.safety.bulletPoint1"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.codeOfConduct.unacceptableBehaviours.behaviours.safety.bulletPoint2"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.codeOfConduct.unacceptableBehaviours.behaviours.safety.bulletPoint3"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.codeOfConduct.unacceptableBehaviours.behaviours.safety.bulletPoint4"
              })
            })]
          })]
        }), /*#__PURE__*/_jsxs(Section, {
          children: [/*#__PURE__*/_jsx(Heading, {
            as: "h3",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.enforcement.title"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.enforcement.introduction"
            })
          }), /*#__PURE__*/_jsx(Heading, {
            as: "h4",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.enforcement.warning.title"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.enforcement.warning.body"
            })
          }), /*#__PURE__*/_jsx(Heading, {
            as: "h4",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.enforcement.suspension.title"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.enforcement.suspension.body"
            })
          }), /*#__PURE__*/_jsx(Heading, {
            as: "h4",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.enforcement.expulsion.title"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.enforcement.expulsion.body"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.enforcement.outroduction"
            })
          })]
        }), /*#__PURE__*/_jsxs(Section, {
          children: [/*#__PURE__*/_jsx(Heading, {
            as: "h3",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.reporting.title"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.reporting.body"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "app.codeOfConduct.reporting.contactUs_jsx",
              elements: {
                Link: CUILink
              },
              options: {
                href: 'mailto:abuse@connect.com'
              }
            })
          })]
        }), /*#__PURE__*/_jsxs(Section, {
          children: [/*#__PURE__*/_jsx(Heading, {
            as: "h3",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.agreement.title"
            })
          }), /*#__PURE__*/_jsx(Paragraph, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.codeOfConduct.agreement.body"
            })
          })]
        })]
      })
    })]
  });
}